<script setup lang="ts">
import { Scarcity } from "fungi-types";
import { useI18n } from "vue-i18n";
import { getCardLevel } from "fungi-utils/cardXp";
import { getCardBonus } from "fungi-utils/cardBonus";
import { computed } from "vue";
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    xp?: number;
    season: string;
    scarcity: Scarcity;
    bgColor?: string;
  }>(),
  {
    xp: 0,
  }
);

const bonus = computed(() => {
  return getCardBonus({ xp: props.xp, season: props.season, scarcity: props.scarcity });
});

const cardLevel = computed(() => {
  return getCardLevel(props.xp);
});
</script>

<template>
  <Tooltip>
    <div
      class="rounded-md pr-1.5 pl-1 text-neutral-300 capitalize cursor-pointer text-xs h-full items-center flex"
      :class="props.bgColor ? props.bgColor : 'bg-neutral-900'"
    >
      <span class="">+{{ bonus.total }}</span
      >%
    </div>
    <template #content>
      <div class="w-32 flex flex-col gap-1">
        <div v-if="bonus.season" class="flex flew-row justify-between w-full items-center">
          <div class="capitalize">{{ props.season }}</div>
          <div class="bg-green-60 p-1 py-0.5 rounded-md">+{{ bonus.season }} %</div>
        </div>
        <div class="flex flew-row justify-between w-full">
          <div class="capitalize">{{ t(`scarcities.${scarcity}`) }}</div>
          <div class="bg-green-60 p-1 py-0.5 rounded-md">+{{ bonus.scarcity }} %</div>
        </div>
        <div v-if="cardLevel.currentLevel > 0" class="flex flew-row justify-between w-full">
          <div class="capitalize">{{ t("level") }} {{ cardLevel.currentLevel }}</div>
          <div class="bg-green-60 p-1 py-0.5 rounded-md">+{{ cardLevel.bonus }} %</div>
        </div>
      </div>
    </template>
  </Tooltip>
</template>
